<template>
  <div class="container comment-form">
    <head-nav-bar title="医院满意度调查" :fixed="true" />
    <div class="mt-header-nav">
      <van-cell-group>
        <van-field
          v-for="(item, index) in commentTypes"
          :key="index"
          :label="item.Text"
          :label-width="labelWidth"
        >
          <span slot="input">
            <van-rate v-model="item.Value" />
          </span>
        </van-field>
      </van-cell-group>
      <div class="box" style="margin-top:1rem">
        <van-button type="info" block @click="onSubmit">确认提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { CellGroup, Field, Rate, Button, Toast } from "vant";
export default {
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Rate.name]: Rate,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  data() {
    return {
      labelWidth: 120,

      form: {
        a: 0,
      },
      commentTypes: [],
    };
  },
  created() {
    this.getCommentType();
  },
  methods: {
    getCommentType() {
      this.$post("Common_SelectData", { Code: "HospitalItemType" }).then(
        res => {
          this.commentTypes = res.data.HospitalItemType;
        },
      );
    },
    onSubmit() {
      console.log(this.commentTypes);
      let Items = [];
      this.commentTypes.forEach(v => {
        if (v.Value && v.Value != "" && typeof v.Value === "number") {
          const json = {
            Id: v.Id,
            ItemTypeValue: v.Value,
          };
          Items.push(json);
        }
      });
      const params = {
        CommentItems: Items,
      };
      this.$post("Comment_Hospital_Add", params).then(() => {
        // Toast.success(msg);
      });
    },
  },
};
</script>

<style></style>
